import React from 'react';
import { ResumeAdditional } from '@cp/entities/resume';
import { AuthorRegistrationDate } from '@cp/entities/resume/ui/authorRegistrationDate';
import { useHasAdditionalParameters } from 'src/entities/resume/model';
import { Tariffs } from '../../tariffs';
import { HiddenProps } from './model';

export const Hidden: React.FC<HiddenProps> = ({ data }) => {
  const hasAdditionalParameters = useHasAdditionalParameters(data);

  return (
    <div
      role="region"
      style={{
        overflow: 'hidden',
        minHeight: 0,
        height: 0,
        visibility: 'hidden',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      }}
    >
      {data.tariffs ? <Tariffs data={data.tariffs} /> : undefined}
      {hasAdditionalParameters && <ResumeAdditional data={data} />}
      <AuthorRegistrationDate data={data} />
    </div>
  );
};
